import { NitroModules } from "react-native-nitro-modules";
var hybrid;
function getInfo() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneDevice");
  return hybrid.getInfo();
}
function getLocalizationInfo() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneDevice");
  return hybrid.getLocalizationInfo();
}
var Device = Object.freeze({
  getInfo,
  getLocalizationInfo
});
export {
  Device
};
//# sourceMappingURL=index.native.js.map
